import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios/index'

/*if (process.env.NODE_ENV === 'production') {
  require('./plugins/vue.matomo')
}*/

axios.defaults.baseURL = process.env.VUE_APP_API

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
